import { Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { findIndex, takeUntil } from 'rxjs/operators';
import { ColumnMode, DatatableComponent } from "@swimlane/ngx-datatable";
import { first } from 'rxjs/operators';

import { SupportService } from '../../../../app/main/pages/support/support.service';
import { CustomerService } from '../../../../services/customer.service';
import { log } from 'console';
import { SharedLocationService } from 'services/shared-location.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SupportComponent implements OnInit, OnDestroy {
  @ViewChild(DatatableComponent) table: DatatableComponent;

  // public
  public contentHeader: object;
  public data: any;
  public searchText: string;
  public rows: any[] = []; // Ensure val is initialized as an empty array

  public ColumnMode = ColumnMode;
  public  todo: any = {
    title: '',
    description: '',
    priority: '3',
    category: 'bug',
    image: {name: "Choose File"}  

  }
  public uploadImage: any = null;

  
  public selected: any;
  public loading: boolean = false;
  public loadingbtn: boolean = false;  

  // private

  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {SupportService} _supportService
   * @param {SharedLocationService} _sharedLocationService
   */
  constructor(
    private _supportService: SupportService, 
    private _customersService: CustomerService,
    private _sharedLocationService: SharedLocationService, 
    ) {
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Changes
   */
  ngOnInit(): void {
    this._supportService.onFAQChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      this.data = response;
    });

    this._supportService.onSupportsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      this.rows = response;    
      if (Array.isArray(response)) {
        this.rows = response; // Make sure the data is an array before assigning
      } else {
        this.rows = []; // Fallback to empty array if data is not an array
      }       
    });

    this._sharedLocationService
      .getLocationChangeEmitter()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((locationId: number) => {
        this.loading = true;
        this._supportService.getDataTableRowsSupport().then(()=> {
          this.loading = false;
        });
      });
  }

    getDate(date: number) {
      let correctDate = new Date(date);
      return correctDate;
    }

  /**
   * Add Todo
   */
  addTodo(todoForm) {
    if (todoForm.valid) {   
      this.loadingbtn = true;
      this._supportService.addSupport(todoForm.form.value, this.uploadImage).then(() => {
        this.todo =
        {
          title: '',
          description: '',
          priority: '3',
          category: 'bug',
          image: {name: "Choose File"}
      
        };        
        this.loadingbtn = false;
      });
    }
  }

      /**
   * Upload Image
   *
   * @param event
   */
    uploadFile(event: any) {
      const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];

      if (event.target.files && event.target.files[0] && (allowedTypes.includes(event.target.files[0].type || ""))) {
        
        let reader = new FileReader();

        reader.onload = (event: any) => {
          this.uploadImage = event.target.result;          
        };
        this.todo.image = event.target.files[0];                

        reader.readAsDataURL(event.target.files[0]);
      }else{
        Swal.fire({
          title: "Error",
          text: "This upload Must be an image file.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-secondary",
          },
        });

      }
    }
  
    isImg() {
      const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
      return allowedTypes.includes(this.todo?.image?.type || "");
    }
  

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
